function LineClipPath({content, xtraClass, textClass}) {
  
    
    return (
        <div className={`_index_1cfqm_192 ${xtraClass ? xtraClass : ''}`}>
            <div className="_divider_ucnqf_2">
                <div className="_line_ucnqf_8" data-collapsed="false"></div>
                <div className="_notch_ucnqf_30" data-collapsed="false" ></div>
            </div>
            <span className={`_indexNumber_1cfqm_201 ${textClass ? textClass : ''}`}>{content}</span>
        </div>
    )
}

export default LineClipPath;